import React, { useState } from "react";
import { PlusIcon } from "../../modules/default-svg";
import { Search, X, Filter, FilterX } from "lucide-react";
import styles from "./RemindersDrawer.module.scss";

const RemindersHeader = (props) => {
  const { setIsModalOpen, modalType, setIsCreate, handleSearch, loading, onFilterChange } = props;
  const [searchValue, setSearchValue] = useState("");
  const [isFilterActive, setIsFilterActive] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
    modalType("reminder");
    setIsCreate(true);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    handleSearch(value);
  };

  const handleClearSearch = () => {
    setSearchValue("");
    handleSearch("");
  };

  const handleFilterClick = () => {
    const newFilterState = !isFilterActive;
    setIsFilterActive(newFilterState);
    if (onFilterChange) {
      onFilterChange(newFilterState);
    }
  };

  return (
    <div className={styles.reminderHeader}>
      <div className={styles.searchWrapper}>
        <div className={styles.searchInputWrapper}>
          <Search className={styles.searchIcon} size={16} />
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Search reminders..."
            value={searchValue}
            onChange={handleSearchChange}
            disabled={loading}
          />
          {searchValue && (
            <button
              className={styles.clearButton}
              onClick={handleClearSearch}
              type="button"
            >
              <X size={16} />
            </button>
          )}
        </div>
      </div>

      <button
        className={`${styles.filterButton} ${isFilterActive ? styles.filterActive : ''}`}
        onClick={handleFilterClick}
        disabled={loading}
        title={isFilterActive ? "Show all reminders" : "Show unread only"}
      >
        {isFilterActive ? <FilterX size={16} /> : <Filter size={16} />}
      </button>

      <button
        className={styles.addButton}
        onClick={handleOpenModal}
        disabled={loading}
        title="Create reminder"
      >
        <PlusIcon />
      </button>
    </div>
  );
};

export default RemindersHeader;
